import styled, { css } from 'styled-components';
import { Box, Avatar } from '@bechtel/gds';

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export const CaddyContainerStyled = styled(Box).attrs({
  py: { sm: '450' },
  mx: { sm: '500' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
  `}
`;

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
    margin-right: ${theme.spacings[300]};
  `}
`;

export const StencilItemStyled = styled(Box).attrs({
  mb: { sm: '500' },
  alignItems: { sm: 'center' },
})`
  border-width: 1px !important;
  width: fit-content;
`;
